export default function Button(props){
    if(props.type==="primary"){
      return (<button className={props.className} onClick={props.onClick}>{props.name}</button>)
    }
    if(props.type==="secondary"){
      return (<button className={`${props.className} .secondary` }onClick={props.onClick}>{props.name}</button>)
    }
}